import ApiFetcher2 from 'static/three-oh/src/modules/apis/ApiFetcher2';

class ContentLikeApi {
  static get() {
    return ApiFetcher2.get('content-bookmark/');
  }

  static save(contentId) {
    return ApiFetcher2.post('content-bookmark/', {data: {content_id: contentId}});
  }

  static delete(likeId) {
    if (likeId) {
      return ApiFetcher2.delete('content-bookmark/' + likeId);
    }
  }
}

export default ContentLikeApi;
